import { Box, Flex, SimpleGrid, Text } from "@chakra-ui/react";
import { motion, Reorder } from "framer-motion";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { MdDeleteOutline } from "react-icons/md";
import { removeUnderscore } from "../../../utils/removedUnderScore";

const LeftSidePreview = ({ mergedData, setMergedData, highlighted }) => {
  const [addressList, setAddressList] = useState([]);

  // Initialize addressList from mergedData.previewAddress
  useEffect(() => {
    if (mergedData?.previewAddress) {
      setAddressList(Array.from(mergedData.previewAddress));
    }
  }, [mergedData?.previewAddress]);

  // Handle reordering addresses
  const handleReorderAddresses = (newKeys) => {
    const newAddressList = newKeys.map((k) => [k, addressMap[k]]);
    setAddressList(newAddressList);
    setMergedData((prev) => ({
      ...prev,
      previewAddress: new Map(newAddressList),
    }));
  };

  // Handle removing an address
  const handleRemoveAddress = (keyToRemove) => {
    const filteredList = addressList.filter(([key]) => key !== keyToRemove);
    setAddressList(filteredList);
    setMergedData((prev) => ({
      ...prev,
      previewAddress: new Map(filteredList),
    }));
  };

  const addressIds = addressList.map(([key]) => key);
  const addressMap = Object.fromEntries(addressList); // key -> address object

  return (
    <Box>
      {/* Basic Information Preview */}{" "}
      <Text fontWeight={500} mb={1}>
        Basic Information(Preview){" "}
      </Text>{" "}
      <Box w="100%" p={2} borderRadius="md" bg="gray.100">
        {Object?.keys(mergedData)
          ?.filter(
            (key) =>
              key !== "ADDRESS" &&
              key !== "HISTORY" &&
              key !== "id" &&
              key !== "START_DATE" &&
              key !== "CREATE_DATE" &&
              key !== "TYPE" &&
              key !== "_rid" &&
              key !== "_self" &&
              key !== "_etag" &&
              key !== "_attachments" &&
              key !== "_ts" &&
              key !== "MATCH_SCORE" &&
              key !== "DEDUPLICATION" &&
              key !== "DEDUPLICATION_ID" &&
              key !== "Type" &&
              key !== "previewAddress"
          )
          .map((key, idx) => (
            <Flex
              key={idx}
              alignItems="center"
              justifyContent="space-evenly"
              mb="2px"
            >
              {" "}
              <Box textAlign="left" w="40%" fontSize="10px" fontWeight={700}>
                {removeUnderscore(key)}{" "}
              </Box>{" "}
              <Box textAlign="center"> : </Box>{" "}
              <Box textAlign="left" width="60%" ml={4} fontSize="xs">
                <motion.div
                  key={JSON.stringify(mergedData[key])}
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  style={{
                    fontSize: "14px",
                    padding: "2px",
                    borderRadius: "5px",
                    backgroundColor: highlighted[key]
                      ? "#ffe066"
                      : "transparent",
                    transition: "background-color 1s ease-in-out",
                  }}
                >
                  {Array.isArray(mergedData[key]) ? (
                    mergedData[key].map((item, index) => (
                      <Text key={index}>{item}</Text>
                    ))
                  ) : key === "BIRTH_DATE" ? (
                    <Text>
                      {moment(
                        mergedData[key],
                        ["YYYYMMDD", "MM/DD/YYYY"],
                        true
                      ).isValid()
                        ? moment(mergedData[key], [
                            "YYYYMMDD",
                            "MM/DD/YYYY",
                          ]).format("MM/DD/YYYY")
                        : mergedData[key]}{" "}
                    </Text>
                  ) : (
                    <Text>{mergedData[key]}</Text>
                  )}
                </motion.div>{" "}
              </Box>{" "}
            </Flex>
          ))}
      </Box>
      {/* Address Preview */}
      {addressList.length > 0 && (
        <Box mt={4}>
          <Text my={1} fontSize="md" fontWeight={500}>
            Address (Preview)
          </Text>

          <Reorder.Group
            axis="y"
            values={addressIds}
            onReorder={handleReorderAddresses}
          >
            {addressIds.map((key, i) => {
              const value = addressMap[key]; // get the address data
              return (
                <Reorder.Item
                  key={key}
                  value={key}
                  whileDrag={{ scale: 1.02 }}
                  style={{ listStyle: "none", marginBottom: 8 }}
                >
                  <Box
                    p={2}
                    border="1px solid gray"
                    borderRadius="md"
                    w="100%"
                    fontSize="xs"
                    bg="white"
                    boxShadow="sm"
                    cursor="grab"
                    _hover={{ boxShadow: "md" }}
                  >
                    <Flex
                      justifyContent="space-between"
                      alignItems="center"
                      mb={1}
                    >
                      <Text fontWeight="bold" fontSize="sm">
                        Address #{i + 1}
                      </Text>
                      <MdDeleteOutline
                        fontSize="20px"
                        onClick={() => handleRemoveAddress(key)}
                        cursor="pointer"
                        color="red"
                      />
                    </Flex>

                    <SimpleGrid columns={2} spacing={1}>
                      {Object.entries(value).map(([field, fieldValue], j) => (
                        <Flex key={j} alignItems="center" mb={2}>
                          <Box
                            textAlign="left"
                            w="40%"
                            fontWeight={700}
                            fontSize="10px"
                          >
                            {removeUnderscore(field)}
                          </Box>
                          <Box textAlign="center" fontWeight={500}>
                            :
                          </Box>
                          <Box textAlign="left" ml={4} w="60%">
                            <Text fontSize="12px">
                              {field === "START_DATE"
                                ? moment(fieldValue, "YYYYMMDD").format(
                                    "MM/DD/YYYY"
                                  )
                                : field === "END_DATE" && fieldValue !== null
                                ? moment(fieldValue, "YYYYMMDD").format(
                                    "MM/DD/YYYY"
                                  )
                                : fieldValue}
                            </Text>
                          </Box>
                        </Flex>
                      ))}
                    </SimpleGrid>
                  </Box>
                </Reorder.Item>
              );
            })}
          </Reorder.Group>
        </Box>
      )}
    </Box>
  );
};

export default LeftSidePreview;
